import React, { useRef, useEffect } from "react";
import useMouse from "@react-hook/mouse-position";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";

import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import useScaleImageEffect from "../lib/useScaleImageEffect";
import shield from "../images/shield-blank-red.svg";

import styles from "./team-member-card.module.css";

gsap.registerPlugin(CustomEase);

const TeamMemberCard = (props) => {
  const { firstName, lastName, jobTitle, image, flavor } = props;
  const rootRef = useRef(null);
  const portraitRef = useRef(null);
  const shieldRef = useRef(null);
  const flavorRefs = [];

  useScaleImageEffect(rootRef, portraitRef, false, 1.25);

  const mouse =
    typeof window !== `undefined`
      ? useMouse(rootRef, {
          enterDelay: 10,
          leaveDelay: 10,
        })
      : null;

  const effectDuration = 0.15;

  CustomEase.create("custom", "M0,0 C0.082,0.104 0.626,1.22 0.8,1.2 0.91,1.2 1,1 1,1");

  useEffect(() => {
    if (mouse.isOver) {
      //mouse in
      flavorRefs.forEach((flavorRef, index) => {
        gsap.to(flavorRef.current, {
          duration: effectDuration,
          ease: "custom",
          scale: 1,
          delay: index * 0.05,
        });
      });
      gsap.to(shieldRef.current, {
        duration: 0.4,
        scale: 1.1,
        yPercent: -50,
        y: 6,
      });
    } else {
      //mouse out
      flavorRefs.forEach((flavorRef, index) => {
        gsap.to(flavorRef.current, { duration: effectDuration, scale: 0, delay: index * 0.05 });
      });
      gsap.to(shieldRef.current, {
        duration: 0.4,
        scale: 1,
        yPercent: -50,
        y: 0,
      });
    }
  }, [mouse]);

  return (
    <div ref={rootRef} className={styles.root}>
      <div className={styles.imageWrapper}>
        <img src={shield} ref={shieldRef} alt="Capacity Shield" className={styles.shield} />
        <img
          ref={portraitRef}
          className={styles.image}
          src={imageUrlFor(buildImageObj(image)).auto("format").quality(100).url()}
          alt={image.alt}
        />
        {flavor && (
          <div className={styles.flavorBubbles}>
            {flavor.map((flavor, index) => {
              const flavorRef = useRef(null);
              flavorRefs.push(flavorRef);
              return (
                <div ref={flavorRef} className={styles.flavorSingle} key={index}>
                  {flavor}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className={styles.info}>
        <h3>
          {firstName}
          <br />
          {lastName}
        </h3>
        {jobTitle && <div className={styles.jobTitle}>{jobTitle}</div>}
      </div>
    </div>
  );
};

export default TeamMemberCard;
